import React from "react";
import { connect } from "react-redux";
import { Header, Grid, Modal, Button, Icon, Label } from "semantic-ui-react";
import { unformatTime, getFormattedValue } from "../../utils/helpers";
import moment from "moment-business-days";
import Field from "../misc/Field";
import DatePicker from "react-datepicker";
import ClientField from "../misc/ClientField";
import Flagship from "../../core/flagship";

class TimeEntryEditModal extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = this.getInitialState(props);
    this.updateNotes = this.updateNotes.bind(this);
    this.updateDate = this.updateDate.bind(this);
    this.updateTask = this.updateTask.bind(this);
    this.updateHoursTracked = this.updateHoursTracked.bind(this);
    this.updateClient = this.updateClient.bind(this);
    this.saveAndExit = this.saveAndExit.bind(this);
    this.deleteAndExit = this.deleteAndExit.bind(this);
  }

  getInitialState(props) {
    return {
      date: props.date,
      client: {
        id: props.client,
        type: "client",
        link: "/client/view/" + props.record_key,
        key: props.record_key,
        name: props.record_name
      },
      hours: props.hours,
      notes: props.notes,
      task: props.task,
      pickingClient: false
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.open !== prevProps.open) {
      this.setState(this.getInitialState(this.props));
    }
  }

  updateDate(date) {
    this.setState({
      date
    });
  }

  updateHoursTracked(e) {
    let hours = e.target.value;
    let timeFormat = /^([0-9]{1,2})\:([0-9]{2})$/;
    if (timeFormat.test(hours)) {
      hours = unformatTime(hours);
    }

    this.setState({
      hours: hours
    });
  }

  updateTask(e, data) {
    this.setState({
      task: data
    });
  }

  updateNotes(e, data) {
    this.setState({
      notes: data
    });
  }

  updateClient(e, data) {
    this.setState({
      client: data.value
    });
  }

  saveAndExit() {
    let { date, hours, task, notes, client } = this.state;

    this.props.onUpdateEntry({
      date,
      hours,
      task,
      notes,
      client,
      id: this.props.id
    });
  }

  deleteAndExit() {
    this.props.onDeleteEntry({
      id: this.props.id
    });
  }

  render() {
    let entryDate = moment(this.state.date, "YYYY-MM-DD").format("MM/DD/YYYY");

    return (
      <Modal
        open={this.props.open}
        onClose={this.props.cancelEdit}
        closeOnDimmerClick={false}
        closeIcon
        width={500}
      >
        <Header icon="clock" content="Edit Time Entry" />
        <Modal.Content>
          <div>
            <Grid>
              <Grid.Column width={16}>
                <div style={{ padding: "0 0 1em" }}>
                  <Label size="large">Entry Date</Label>
                  <br />
                  <div className="small-field">
                    <div className="field-container clearfix">
                      <div className="ui fluid input">
                        <DatePicker
                          label="Entry Date"
                          fluid
                          value={
                            entryDate !== ""
                              ? getFormattedValue(
                                  entryDate,
                                  this.props.validation
                                )
                              : ""
                          }
                          placeholder="Select a date"
                          onChange={this.updateDate}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div style={{ padding: "0 0 1em" }}>
                  <div className="flagship-single-field">
                    <div className="flagship-input">
                      <div>
                        <Label className="single-field-label" size="large">
                          Client
                        </Label>

                        <ClientField
                          value={this.state.client}
                          onChange={(e, data) => this.updateClient(e, data)}
                          placeholder="Begin typing to select a client..."
                          disableAddNew={true}
                          anyInstance={true}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <Field
                  type="text "
                  label="Hours"
                  validation="decimalOrTime"
                  value={this.state.hours}
                  onChange={this.updateHoursTracked}
                />

                <Field
                  type="select"
                  label="Category"
                  value={this.state.task}
                  onChange={this.updateTask}
                  options={Flagship.config.timeTrackerTasks}
                />
                <small style={{ color: "#666" }}>
                  Select the service or activity that this time falls under.
                </small>

                <Field
                  type="textarea"
                  label="Notes (Optional)"
                  validation="none"
                  value={this.state.notes}
                  onChange={this.updateNotes}
                />
              </Grid.Column>
            </Grid>
          </div>
        </Modal.Content>
        <Modal.Actions>
          <Button color="teal" onClick={this.saveAndExit}>
            <Icon name="clock" /> Update Entry
          </Button>
          <Button color="red" onClick={this.deleteAndExit}>
            <Icon name="delete" /> Delete Entry
          </Button>
          <Button color="grey" onClick={this.props.cancelEdit}>
            <Icon name="dont" /> Cancel
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

function mapStateToProps(state) {
  return {
    username: state.main.username,
    userId: state.main.userId,
    userRole: state.main.userRole
  };
}

export default connect(mapStateToProps, null)(TimeEntryEditModal);



// WEBPACK FOOTER //
// ./src/components/modals/TimeEntryEditModal.js